import { useGetUsers } from "api/generated/users/users";

export const useSearchUserQuery = (search: string) =>
    useGetUsers(
        { format: "Overview", nameOrEmail: search },
        {
            query: {
                select: (response) => {
                    if (response.data.type !== "Overview") {
                        throw new Error("Expected an overview user list");
                    }
                    return response.data.data.content.map(
                        (dto) => dto.resource
                    );
                },
                enabled: search.length > 0,
                staleTime: 30 * 1000,
            },
        }
    );
